import { render, staticRenderFns } from "./MenuItemNumberSpan.vue?vue&type=template&id=7191a1d0&"
import script from "./MenuItemNumberSpan.vue?vue&type=script&lang=ts&"
export * from "./MenuItemNumberSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports